import BookingCard from '../BookingCard';
import { BookingCardProps } from '../BookingCard/index.types';
import MessageBubble from '../MessageBubble';
import { WidgetProps } from './index.types';

function BookingConfirmation({ message, widgetData }: WidgetProps) {
    const { actor } = message;
    const data = widgetData.parameters as BookingCardProps['bookingData'];

    return (
        <MessageBubble actor={actor} className='!p-10'>
            <BookingCard bookingData={data} />
        </MessageBubble>
    );
}

export default BookingConfirmation;
